// useSearch.ts
import {
  createContext,
  ReactNode,
  useContext,
  useState,
} from "react";

export const UserTypes = {
  neweyes: 1,
  agency: 2,
  caseworker: 3,
  registered: 5,
};

export interface SearchOption {
  voucherStatus: string;
  cannedDateRange: number;
  startDate: Date;
  endDate: Date;
  sortBy: string;
  searchText: string;
}

export const EmptySearchOption: SearchOption = {
  voucherStatus: 'all',
  cannedDateRange: 5,
  startDate: new Date(),
  endDate: new Date(),
  sortBy: 'date',
  searchText: '',
};

interface SearchHook {
  userType: number;
  setUserView: (userType: number) => void;
  searchOption: SearchOption;
  setSearchOption: (searchOption: SearchOption) => void;
}

const SearchContext = createContext<SearchHook>({
  userType: UserTypes.neweyes,
  setUserView: () => null,

  searchOption: EmptySearchOption,
  setSearchOption: () => null,
});

interface SearchProviderProps {
  children: ReactNode;
}

export const SearchProvider = ({ children }: SearchProviderProps) => {
  const auth = useSearchProvider();
  return <SearchContext.Provider value={auth}> {children} </SearchContext.Provider>;
};

export const useSearch = () => useContext(SearchContext);

const useSearchProvider = (): SearchHook => {
  const [userType, setUserView] = useState(UserTypes.neweyes);
  const [searchOption, setSearchOption] = useState<SearchOption>(EmptySearchOption);

  return {
    userType,
    setUserView,
    searchOption,
    setSearchOption,
  };
};

export default useSearch;
